export default "__VITE_ASSET__b30e7425__"